import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/retur-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/retur-obat/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/retur-obat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/retur-obat/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/retur-obat/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

async function addItem(returId: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${returId}/item`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateItem(returId: number, itemId: number, data: any) {
  const response = await http
    .putData(`/retur-obat/${returId}/item/${itemId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteItem(returId: number, itemId: number) {
  const response = await http
    .deleteData(`/retur-obat/${returId}/item/${itemId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function addFromResep(returId: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${returId}/add-from-resep`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPerawat(id: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${id}/sign-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSaksi(id: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${id}/sign-saksi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function kirim(id: number) {
  const response = await http
    .postData(`/retur-obat/${id}/kirim`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyItem(returId: number, itemId: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${returId}/item/${itemId}/verify`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyBulk(id: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${id}/verify-bulk`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signFarmasi(id: number, data: any) {
  const response = await http
    .postData(`/retur-obat/${id}/sign-farmasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function listPending(depoId?: string) {
  const params = depoId ? `?depo_id=${depoId}` : "";
  const response = await http
    .getData(`/retur-obat-pending${params}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/retur-obat/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  addItem,
  updateItem,
  deleteItem,
  addFromResep,
  signPerawat,
  signSaksi,
  kirim,
  verifyItem,
  verifyBulk,
  signFarmasi,
  listPending,
  printPdf,
};
